import { lowerFirst, upperFirst } from 'lodash';

const exceptions = new Set<string>(['a', 'an', 'the', 'on', 'in', 'for', 'of', 'and']);

// snake_case functions
// snake_case_text => snake case text
export function snakeCaseToRegular(text: string) {
  return text.replace(/_/g, ' ');
}

// the_snake_case_text => the Snake Case Text
export function snakeCaseToCapitalize(text: string) {
  let textArray = text.split('_');
  textArray = textArray.map((item) => (exceptions.has(item) ? item : upperFirst(item)));
  return textArray.join(' ');
}

// snake_case_text => Snake case text
export function humanize(text: string) {
  return text.split('_').map(upperFirst).join(' ');
}

// SCREAMING_SNAKE_CASE
export function screamingSnakeCaseToCapitalize(text: string, additionalExceptions?: string[]): string {
  let otherExceptions = new Set<string>(additionalExceptions || []);
  let textArray = text.split('_').map((str) => {
    let lower = str.toLowerCase();
    return exceptions.has(lower) || otherExceptions.has(lower) ? lower : upperFirst(lower);
  });
  return textArray.join(' ');
}

// like snake case to Regular, this does not upperFirst the first word.
export function camelCaseToRegular(text: string, additionalExceptions?: string[]): string {
  let otherExceptions = new Set<string>(additionalExceptions || []);
  let textArray = text.split(/(?<=[a-z])(?=[A-Z])|(?<=[A-Z])(?=[A-Z][a-z])/g);
  return textArray
    .map((word) =>
      exceptions.has(lowerFirst(word)) || otherExceptions.has(lowerFirst(word)) // exceptions is a set of lower case words
        ? lowerFirst(word)
        : word
    )
    .join(' ');
}

export const camelCaseToTitleCase = (text: string) => upperFirst(camelCaseToRegular(text));
